// @core/api/endpoints/booking/cancel_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  CancelBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Cancel booking
 * Cancels any confirmed booking. Applies cancellation penalty per policy tiers, processes refund, frees the calendar slot, and notifies waitlist entries of the newly available slot.
 */
export async function CancelBooking(
  target_type: string,
  target_id: string,
  data: CancelBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/cancel`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
